module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-15@2x-083bd8e13aff08f098a194e22424e038.png";